module.exports = __webpack_public_path__ + "img/alerts.b4fddcf9.svg";